/** Hooks */
import { useTicketSubmissionMutation } from '@features/redux/apis/tickets';
import { Fragment, useEffect, useState } from 'react';
import { useStyles } from '../Tickets.styles';
import { useQuery } from '@hooks/useQuery';

/** MUI */
import { Typography, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';

/** MO Components */
import { FormRequiredText } from '@components/forms/text/base/FormRequiredText';
import { FormSelect } from '@components/forms/dropdowns/base/FormSelect';
import { TicketEffects } from './Effects';

/** Utils */
import { Validate } from '@utils/validate';
import { FormTextArea } from '@components/forms/text/base/FormTextArea';
import { TicketContainer } from '../TicketContainer';
import { FormCheckBox } from '@components/forms/FormCheckBox';

const issueTypes = [
  { label: 'General', value: 'standard' },
  { label: 'Network' , value: 'network-lockout' }
];

export const Tickets = () => {
    /** Hooks  */
    const [submitTicket, mutationState] = useTicketSubmissionMutation({
      fixedCacheKey: 'SubmitTicketMutation'
    });

    const classes = useStyles();

    const draft = useState({
      ticketType: '',
      serialNum: '',
      locationId: '',
      locationName: '',
      customerEmail: '',
      customerName: '',
      customerPhone: '',
      description: '',
      withCustomer: false,
      ipAddress: '',
      networkStatus: ''
    } as Record<string, any>);

    const [draftState] = draft;

    /** Components */
    return (
       <Fragment>
          <TicketEffects draft={draft} />

          <TicketContainer>
            <Box display={'flex'} flexDirection={'column'} gap={'5px'} justifyContent={'center'}>

              <Typography className={classes.title}> Open a support ticket</Typography>

              <Typography className={classes.textDisplay}> Complete the fields below to submit a support request - please be as specific and thorough as possible. <br /> </Typography>
              <Typography className={classes.textDisplay}>  A team member will contact you during our normal business hours (Monday - Friday, 3:00 a.m. - 5:00 p.m. ET).</Typography>
              <Typography className={classes.textDisplay} marginBottom={'3vh'}> We understand that these issues are urgent, and will respond as quickly as possible - thank you for your patience</Typography>
                {/*ToDo: Make these mirror form type */}
              { draftState.ticketType ? <></> : (
                <FormSelect label='Issue Category' draft={draft} stateKey='ticketType' options={issueTypes} />
              )}

              <FormRequiredText label='Your Name' draft={draft} stateKey='customerName' validateFn={Validate.name} />

              <FormRequiredText label='Your email' draft={draft} stateKey={'customerEmail'} type='email' validateFn={Validate.Auth.email} />
              <FormRequiredText label='WhatsApp or Mobile Phone # (Include country code)' draft={draft} stateKey={'customerPhone'} validateFn={()=>true } />
              { draftState.serialNum ? <></> : (
                <FormRequiredText label='RapidCut Serial Number' draft={draft} stateKey='serialNum' validateFn={Validate.name} />
                )}

              { draftState.locationId ? <></> : (
                <>
                <FormRequiredText label='Rapidcut Tablet ID' draft={draft} stateKey={'locationId'} validateFn={Validate.name} />
                <FormRequiredText label='Your Company Name' draft={draft} stateKey='companyName' validateFn={() => true} />
                <FormRequiredText label='Location Name  (include mall or store name)*' draft={draft} stateKey='locationName' validateFn={() => true} /></>
              )}

              <FormTextArea placeholder='Description of the issue...' draft={draft} stateKey={'description'} />
              <FormCheckBox draft={draft} stateKey={'withCustomer'} label='Are you with a customer right now?' values={{ checked: true, unchecked: false }} />

              {/** ToDo: Add Video capture & post */}
              <LoadingButton
                  loading={mutationState.isLoading}
                  variant={'contained'}
                  disabled={
                    !Validate.Auth.email(draft[0].customerEmail) ||
                    !Validate.name(draft[0].description)
                  }
                  onClick={() => {
                     submitTicket({
                      ...draft[0]
                    });
                  }}>
                Submit
              </LoadingButton>
            </Box>

          </TicketContainer>
        </ Fragment>
    );
};
